import { EllipsisHorizontalIcon } from "@heroicons/react/16/solid";
import { PencilIcon } from "@heroicons/react/24/outline";
import { Button } from "./tailwind/button";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "./tailwind/dropdown";
import { Field, Fieldset } from "./tailwind/fieldset";
import { Input } from "./tailwind/input";
import SelectInput from "./tailwind/select-input";
import { SwitchAutomation, SwitchField } from "./tailwind/switch";

export function PageHeading({
  title,
  searchPlaceholder,
  search,
  setSearch,
  primaryAction,
  iconPrimaryAction,
  isPrimaryLoading,
  isPrimaryDisabled,
  handlePrimaryAction,
  secondaryAction,
  iconSecondaryAction,
  isSecondaryLoading,
  isSecondaryDisabled,
  handleSecondaryAction,
  thirdAction,
  iconThirdAction,
  isThirdLoading,
  isThirdDisabled,
  handleThirdAction,
  titleAction,
  handleTitleAction,
  dropdownButton,
  dropdownItems,
  editAutomationOrChatbot,
  checked,
  onChange,
  select,
  selectComponents,
  actionsBelow = false,
}) {
  const actions = (
    <>
      {dropdownButton && (
        <div className="mr-4">
          <Dropdown>
            <DropdownButton plain aria-label="More options">
              <EllipsisHorizontalIcon />
            </DropdownButton>
            <DropdownMenu anchor="bottom end">
              {dropdownItems.map((item, index) => (
                <DropdownItem key={index} onClick={item.onClick}>
                  {item.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      )}
           {thirdAction && (
        <Button
          color="secondaryButton"
          className={secondaryAction ? "mr-4" : "mr-0"}
          onClick={handleThirdAction}
          loading={isThirdLoading}
          disabled={isThirdDisabled}
        >
          {iconThirdAction}
          {thirdAction}
        </Button>
      )}
      {secondaryAction && (
        <Button
          color="secondaryButton"
          className={primaryAction ? "mr-4" : "mr-0"}
          onClick={handleSecondaryAction}
          loading={isSecondaryLoading}
          disabled={isSecondaryDisabled}
        >
          {iconSecondaryAction}
          {secondaryAction}
        </Button>
      )}
      {primaryAction && (
        <Button
          color="primaryButton"
          onClick={handlePrimaryAction}
          loading={isPrimaryLoading}
          disabled={isPrimaryDisabled}
        >
          {iconPrimaryAction}
          {primaryAction}
        </Button>
      )}
      {editAutomationOrChatbot && (
        <div className="cursor-pointer">
          <SwitchField>
            <SwitchAutomation
              name="switch_automation"
              checked={checked}
              color="yellow"
              style={{ height: "36px", width: "70px", marginLeft: "-30px" }}
              onChange={onChange}
            ></SwitchAutomation>
          </SwitchField>
        </div>
      )}
      {select && (
        <div className="cursor-pointer w-[11em]">
          <SelectInput
            options={selectComponents.options}
            selected={selectComponents.selected}
            onChange={selectComponents.onChange}
            value={selectComponents.value}
          />
        </div>
      )}
    </>
  );

  return (
    <>
      <div className="flex items-center justify-between border-b pb-3 h-[50px] mt-5 mx-5">
        <div className="min-w-0 flex max-w-full md:max-w-[76%]">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight font-title dark:text-white ">
            {title}
          </h2>

          {titleAction && (
            <Button
              outline
              onClick={handleTitleAction}
              style={{ paddingTop: "3px", margin: "5px" }}
            >
              <PencilIcon className="" />
            </Button>
          )}
        </div>
        <div className="flex md:ml-4 md:mt-0">
          {/* Desktop searchbar */}
          {searchPlaceholder && (
            <Fieldset className="mr-4 hidden md:block">
              <Field>
                <Input
                  autoComplete="off"
                  name={searchPlaceholder}
                  placeholder={searchPlaceholder}
                  value={search ?? ""}
                  key="search"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Field>
            </Fieldset>
          )}
          {!actionsBelow && (
            <>
            {actions}
            </>
          )}
        </div>
      </div>
      {/* Mobile searchbar */}
      {actionsBelow && (
        <div className="flex flex-wrap px-5 mt-3 mb-1 w-full justify-end">
          {actions}
        </div>
      )}
      {searchPlaceholder && (
        <div className="block md:hidden px-5 mt-2 mb-4">
          <Fieldset>
            <Field>
              <Input
                autoComplete="off"
                name={searchPlaceholder}
                placeholder={searchPlaceholder}
                value={search ?? ""}
                key="search-mobile"
                onChange={(e) => setSearch(e.target.value)}
              />
            </Field>
          </Fieldset>
        </div>
      )}
    </>
  );
}
